import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getPathwayTemplateAnalysisResults } from '@/api/pathwayTemplates';

const initialValues = {
  lca: { data: null, loading: false, error: null },
  tea: { data: null, loading: false, error: null },
  lcaBreakdown: { data: null, loading: false, error: null },
  lcaAggregated: { data: null, loading: false, error: null },
  teaAggregated: { data: null, loading: false, error: null },
};

const usePathwayTemplateAnalysisStore = create()(immer(() => initialValues));
const { setState: set } = usePathwayTemplateAnalysisStore;

export const pathwayTemplateAnalysisActions = {
  fetchLca: async (templateId, params = {}) => {
    set(state => {
      state.lca.loading = true;
      state.lca.error = null;
    });

    try {
      const response = await getPathwayTemplateAnalysisResults(templateId, 'lca', params);
      set(state => {
        state.lca.data = response.data;
        state.lca.loading = false;
      });
    } catch (error) {
      set(state => {
        state.lca.error = error;
        state.lca.loading = false;
      });
    }
  },

  fetchTea: async (templateId, params = {}) => {
    set(state => {
      state.tea.loading = true;
      state.tea.error = null;
    });

    try {
      const response = await getPathwayTemplateAnalysisResults(templateId, 'tea', params);
      set(state => {
        state.tea.data = response.data;
        state.tea.loading = false;
      });
    } catch (error) {
      set(state => {
        state.tea.error = error;
        state.tea.loading = false;
      });
    }
  },

  fetchLcaBreakdown: async (templateId, params = {}) => {
    set(state => {
      state.lcaBreakdown.loading = true;
      state.lcaBreakdown.error = null;
    });

    try {
      const response = await getPathwayTemplateAnalysisResults(templateId, 'lca', {
        ...params,
        scope3_breakdown: true,
      });
      set(state => {
        state.lcaBreakdown.data = response.data;
        state.lcaBreakdown.loading = false;
      });
    } catch (error) {
      set(state => {
        state.lcaBreakdown.error = error;
        state.lcaBreakdown.loading = false;
      });
    }
  },

  fetchLcaAggregated: async (templateId, params = {}) => {
    set(state => {
      state.lcaAggregated.loading = true;
      state.lcaAggregated.error = null;
    });

    try {
      const response = await getPathwayTemplateAnalysisResults(templateId, 'lca_aggregated', {
        ...params,
      });
      set(state => {
        state.lcaAggregated.data = response.data;
        state.lcaAggregated.loading = false;
      });
    } catch (error) {
      set(state => {
        state.lcaAggregated.error = error;
        state.lcaAggregated.loading = false;
      });
    }
  },

  fetchTeaAggregated: async (templateId, params = {}) => {
    set(state => {
      state.teaAggregated.loading = true;
      state.teaAggregated.error = null;
    });

    try {
      const response = await getPathwayTemplateAnalysisResults(templateId, 'tea_aggregated', {
        ...params,
      });
      set(state => {
        state.teaAggregated.data = response.data;
        state.teaAggregated.loading = false;
      });
    } catch (error) {
      set(state => {
        state.teaAggregated.error = error;
        state.teaAggregated.loading = false;
      });
    }
  },

  clear: () => set(initialValues, true),
};

export const useLcaData = () => usePathwayTemplateAnalysisStore(state => state.lca);
export const useTeaData = () => usePathwayTemplateAnalysisStore(state => state.tea);
export const useLcaBreakdownData = () => usePathwayTemplateAnalysisStore(state => state.lcaBreakdown);
export const useLcaAggregatedData = () => usePathwayTemplateAnalysisStore(state => state.lcaAggregated);
export const useTeaAggregatedData = () => usePathwayTemplateAnalysisStore(state => state.teaAggregated);

export default usePathwayTemplateAnalysisStore;
